import { useTheme } from "@mui/material";
import { round } from "lodash-es";

import {
  LegendSymbolizerRasterValues,
  LegendColorMapRampEntry,
  useTextMaxWidth,
} from "hooks/legendHooks";

interface Props {
  symbolizer: LegendSymbolizerRasterValues;
}

export function LegendSymbolizerItemRasterValues(props: Props) {
  const {
    symbolizer: { Raster },
  } = props;
  const theme = useTheme();
  const fontSize = theme.typography.fontSize;
  const fontFamily = theme.typography.fontFamily;
  const {
    colormap: { entries },
  } = Raster;
  const { length } = entries;
  const height = fontSize * length * 1.5;
  const entryHeight = height / length;

  const textWidth =
    useTextMaxWidth(
      entries.map((entry, i) => renderLabel(entry, i)),
      fontSize,
      fontFamily || "Arial"
    ) + 110;

  function renderLabel(entry: LegendColorMapRampEntry, index: number) {
    const parts = new Array<string>();
    parts.push(entry.label || round(entry.quantity, 2).toLocaleString());
    return parts.join(" ");
  }

  return (
    <svg x="0" y="0" height={`${height}px`} width={`${textWidth}px`}>
      {entries.map((entry, i) => (
        <g transform={`translate(0,${entryHeight * i})`} key={entry.label}>
          <rect
            color={entry.color}
            opacity={entry.opacity}
            x="0"
            y="0"
            width="10"
            height="10"
          />
          <text
            key={`${entry.quantity}-label`}
            x="15"
            y={`${entryHeight / 2}`}
            fontFamily={fontFamily}
            fontSize={`${fontSize}px`}
          >
            {renderLabel(entry, i)}
          </text>
        </g>
      ))}
    </svg>
  );
}
